import { type FC, useCallback } from 'react';
import type { UrlObject } from 'url';
import { type Analytics, useSportUrlParams } from '@mwl/core-lib';
import { Button } from '@/components/Button/Button';
import { SportIcon } from '@/components/SportIcon/SportIcon';
import { routes } from '@/constants';
import { useIsCyberSportPage } from '@/hooks';
import { getSportToolbarAnalytics } from '../../SportToolbar.analytics';
import type { SportFilterItemProps } from './SportFilterItem.types';
import styles from './SportFilterItem.module.scss';
export const SportFilterItem: FC<SportFilterItemProps> = ({
  sportItem,
  sports,
  className,
  isActive,
  onClick,
  position
}) => {
  const isCyberSportPage = useIsCyberSportPage();
  const {
    createSportItemLink
  } = useSportUrlParams({
    isCyberSportPage,
    routes
  });
  const getAnalyticsData = useCallback((href: UrlObject): Analytics<'click'> => {
    const {
      sportToolbarAnalytics
    } = getSportToolbarAnalytics({
      href,
      count: sports?.length,
      position
    });
    if (isActive) {
      return {
        click: {
          eventName: sportToolbarAnalytics.unselect?.eventName,
          data: sportToolbarAnalytics.unselect?.data
        }
      };
    }
    return {
      click: {
        eventName: sportToolbarAnalytics.select?.eventName,
        data: sportToolbarAnalytics.select?.data
      }
    };
  }, [isActive, position, sports?.length]);
  const href = createSportItemLink(sportItem.id);
  return <Button key={sportItem.id} as="link" href={href} className={cn(styles.root, className)} onClick={onClick} variant="text" rounded shallow analytics={getAnalyticsData(href)} data-sentry-element="Button" data-sentry-component="SportFilterItem" data-sentry-source-file="SportFilterItem.tsx">
      <SportIcon className={styles.icon} isActive={isActive} url={sportItem.icon} size={20} data-sentry-element="SportIcon" data-sentry-source-file="SportFilterItem.tsx" />
      <span className={cn(styles.text, {
      [styles.activeText]: isActive
    })}>{sportItem.title}</span>
    </Button>;
};